import React, { Component } from 'react';
import moment from 'moment';
import axios from 'axios';
import { SimpleMenu, MenuItem } from '@rmwc/menu';
import route from '../../../vendor/tightenco/ziggy/src/js/route';
import { Dialog, DialogTitle, DialogContent, DialogActions, DialogButton } from '@rmwc/dialog';
import { Select } from '@rmwc/select';
import Bugsnag from '../bugsnag';
import { Radio } from '@rmwc/radio';
import { Autocomplete, TextField } from '@mui/material';
import html2canvas from 'html2canvas'; // Import html2canvas


function createElementFromHTML(htmlString) {
    var div = document.createElement('div');
    div.innerHTML = htmlString.trim();

    // Change this to div.childNodes to support multiple top-level nodes
    return div.firstChild;
}

function linkify(text) {
    const urlRegex = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi;
    return {
        __html: text.replace(urlRegex, function (url) {
            return '<a rel="nofollow noopener" target="_blank" href="' + url + '">' + url + '</a>';
        })
    };
}

export default class ScheduleDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            classTypeDetails: null,
            addMemberOpen: false,
            addMemberSelectValue: null,
            addMemberSelectInputValue: null,
            isSubscribing: false,
            isUnsubscribing: false,
            showLoader: false,
            showLoader_image: false,
            editRecurringOpen: false,
            editRecurringValue: null,
            deleteRecurringOpen: false,
            deleteRecurringValue: null,
            imageSrc: null,
            isDialogOpen: false,
        };

        this.captureContentRef = React.createRef(); // Create a ref for the content you want to capture

    }

    handleDownloadImage = (imageSrc, imageName) => {
        // Create a temporary anchor element to trigger the download
        const a = document.createElement('a');
        a.href = imageSrc;
        a.download = imageName;

        // Programmatically trigger a click event on the anchor element
        const clickEvent = new MouseEvent('click', {
            view: window,
            bubbles: true,
            cancelable: false,
        });
        a.dispatchEvent(clickEvent);
    };

    handleOpenDialog = () => {
        // Show the loader
        this.setState({ isDialogOpen: true, showLoader_image: true }, () => {
            // Dialog has just opened, show loader and content for 1 second
            const captureContent = this.captureContentRef.current;

            setTimeout(() => {
                // Generate the image
                html2canvas(captureContent).then((canvas) => {
                    const imageSrc = canvas.toDataURL('image/png');

                    // Update the state with the generated image URL
                    this.setState({ imageSrc });

                    // Hide the loader
                    this.setState({ showLoader: false });
                });
            }, 150); // 1000 milliseconds (1 second) delay
        });
    };


    handleCloseDialog = () => {
        this.setState({ isDialogOpen: false });
    };


    handleCalendarOptionClick(selectedOption) {

        const { event } = this.props;

        const eventTitle = decodeURIComponent(event.title); // Decode the event title
        const eventStartDate = moment(event.start).utc().format('YYYYMMDDTHHmmss[Z]');
        const eventEndDate = moment(event.end).utc().format('YYYYMMDDTHHmmss[Z]');

        if (selectedOption === 'icalendar') {
            const icalendarContent = `BEGIN:VCALENDAR\r\n` +
                `VERSION:2.0\r\n` +
                `BEGIN:VEVENT\r\n` +
                `SUMMARY:${eventTitle}\r\n` + // Use SUMMARY field for event title
                `DTSTART:${eventStartDate}\r\n` +
                `DTEND:${eventEndDate}\r\n` +
                `END:VEVENT\r\n` +
                `END:VCALENDAR`;

            const blob = new Blob([icalendarContent], { type: 'text/calendar;charset=utf-8' });
            const url = URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = url;
            link.target = '_blank';
            link.download = 'event.ics';
            link.click();

        } else if (selectedOption === 'google') {
            const googleCalendarURL = `https://www.google.com/calendar/render?action=TEMPLATE&text=${eventTitle}&dates=${eventStartDate}/${eventEndDate}&sf=true&output=xml`;

            window.open(googleCalendarURL, '_blank');
        } else if (selectedOption === 'outlook') {
            const outlookURL = `webcal://outlook.office.com/owa/?path=/calendar/action/compose&rru=addevent&subject=${eventTitle}&startdt=${eventStartDate}&enddt=${eventEndDate}`;

            window.open(outlookURL, '_blank');
        }
    }

    openAddWorkoutDrawer() {
        document.querySelector(
            '.js-add-workout-form input[name="schedule_id"]'
        ).value = this.props.event.extendedProps.eventId;
        document.querySelector(
            '.js-add-new-workout-form input[name="schedule_id"]'
        ).value = this.props.event.extendedProps.eventId;
        document.querySelector('.js-add-workout-form input[name="schedule_date"]').value = moment(
            this.props.event.start
        ).format('YYYY-MM-DD');
        document.querySelector('.js-add-new-workout-form input[name="schedule_date"]').value = moment(
            this.props.event.start
        ).format('YYYY-MM-DD');

        document.querySelector('.js-add-workout-to-class-drawer').Pushbar.open();
    }

    openEditRecurringForm() {
        // This is done to clear all event listeners
        const form = document.querySelector('.js-edit-class-drawer .js-edit-class-form');
        const newForm = form.cloneNode(true);
        form.parentNode.replaceChild(newForm, form);

        const start = moment(this.props.event.start);
        const end = moment(this.props.event.end);
        document.querySelector(
            '.js-edit-class-drawer select[name="class_type"]'
        ).value = this.props.event.extendedProps.classTypeId;
        document.querySelector('.js-edit-class-drawer input[name="schedule_date"]').value = start.format('YYYY-MM-DD');
        document.querySelector('.js-edit-class-drawer input[name="old_start_date"]').value = start.format(
            'YYYY-MM-DD HH:mm:ss'
        );
        document.querySelector('.js-edit-class-drawer input[name="old_end_date"]').value = end.format(
            'YYYY-MM-DD HH:mm:ss'
        );
        document.querySelector('.js-edit-class-drawer input[name="start_time"]').value = start.format('HH:mm:ss');
        document.querySelector('.js-edit-class-drawer input[name="end_time"]').value = end.format('HH:mm:ss');
        document.querySelector('.js-edit-class-drawer select[name="recurring"]').value = this.props.event.extendedProps
            .isRecurring
            ? 'recurring'
            : 'no-recurring';

        document.querySelector('.js-edit-class-drawer').Pushbar.open();

        function handleSubmit(evt) {
            evt.preventDefault();
            if (that.props.event.extendedProps.isRecurring) {
                evt.currentTarget.dataset.eventListenerSet = '1';
                let dialog = document.querySelector('.js-edit-class-dialog').MDCDialog;
                dialog.open();
                const applyEditClassButton = document.querySelector('.js-apply-edit-class-button');
                evt.target.removeEventListener('submit', handleSubmit);
                dialog.listen('MDCDialog:closing', function handleClosing() {
                    document
                        .querySelector('.js-edit-class-drawer .js-edit-class-form')
                        .addEventListener('submit', handleSubmit);

                    applyEditClassButton.removeEventListener('click', handleClickApply);
                });

                function handleClickApply(event) {
                    const editRadioValue = document.querySelector('input[name=edit-type]:checked').value;
                    if (editRadioValue === 'this-event') {
                        that.editThisClass();
                    } else if (editRadioValue === 'this-and-following-events') {
                        that.editRecurringClass();
                    } else if (editRadioValue === 'all-events') {
                        that.editAllClass();
                    }

                    event.currentTarget.removeEventListener('click', handleClickApply);
                }

                applyEditClassButton.addEventListener('click', handleClickApply);
            }
        }

        const that = this;
        document.querySelector('.js-edit-class-drawer .js-edit-class-form').addEventListener('submit', handleSubmit);
    }

    editOneTimeClass() {
        // This is done to clear all event listeners
        const form = document.querySelector('.js-edit-class-drawer .js-edit-class-form');
        const newForm = form.cloneNode(true);
        form.parentNode.replaceChild(newForm, form);

        newForm.action = route('edit_class_in_schedule_one_time', {
            scheduleId: this.props.event.extendedProps.eventId
        });
        const start = moment(this.props.event.start);
        const end = moment(this.props.event.end);
        document.querySelector(
            '.js-edit-class-drawer select[name="class_type"]'
        ).value = this.props.event.extendedProps.classTypeId;
        document.querySelector('.js-edit-class-drawer input[name="schedule_date"]').value = start.format('YYYY-MM-DD');
        document.querySelector('.js-edit-class-drawer input[name="old_start_date"]').value = start.format(
            'YYYY-MM-DD HH:mm:ss'
        );
        document.querySelector('.js-edit-class-drawer input[name="old_end_date"]').value = end.format(
            'YYYY-MM-DD HH:mm:ss'
        );
        document.querySelector('.js-edit-class-drawer input[name="start_time"]').value = start.format('HH:mm:ss');
        document.querySelector('.js-edit-class-drawer input[name="end_time"]').value = end.format('HH:mm:ss');
        document.querySelector('.js-edit-class-drawer select[name="recurring"]').value = this.props.event.extendedProps
            .isRecurring
            ? 'recurring'
            : 'no-recurring';

        document.querySelector('.js-edit-class-drawer').Pushbar.open();

        const that = this;

        document
            .querySelector('.js-edit-class-drawer .js-edit-class-form')
            .addEventListener('submit', function handleActualSubmit(event) {
                event.preventDefault();

                const loader = event.target.closest('aside').getElementsByClassName('js-loader')[0];
                if (loader) {
                    loader.style.display = 'block';
                }

                const formData = new FormData(event.target);

                const dataToSend = {};

                for (let data of formData) {
                    dataToSend[data[0]] = data[1];
                }

                axios
                    .post(event.target.action, dataToSend)
                    .then(function (result) {
                        if (loader) {
                            loader.style.display = 'none';
                        }
                        event.target.closest('.pushbar').Pushbar.closeAll();
                        that.props.refresh();

                        setTimeout(function () {
                            // This will ensure that after the form was succesfully submitted the form is both
                            // - Scrolled to the top again
                            // - Reset to its initial state
                            event.target.closest('main').scrollTop = 0;
                            event.target.reset();
                        }, 300); // Same timeout as is used for pushbar animation
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
                event.target.removeEventListener('submit', handleActualSubmit);
            });
    }

    editThisClass() {
        const that = this;
        document.querySelector('.js-edit-class-drawer .js-edit-class-form').action = route(
            'edit_class_in_schedule_this',
            {
                scheduleId: this.props.event.extendedProps.eventId
            }
        );
        document
            .querySelector('.js-edit-class-drawer .js-edit-class-form')
            .addEventListener('submit', function handleActualSubmit(event) {
                event.preventDefault();

                const loader = event.target.closest('aside').getElementsByClassName('js-loader')[0];
                if (loader) {
                    loader.style.display = 'block';
                }

                const formData = new FormData(event.target);

                const dataToSend = {};

                for (let data of formData) {
                    dataToSend[data[0]] = data[1];
                }

                axios
                    .post(event.target.action, dataToSend)
                    .then(function (result) {
                        if (loader) {
                            loader.style.display = 'none';
                        }
                        event.target.closest('.pushbar').Pushbar.closeAll();
                        that.props.refresh();

                        setTimeout(function () {
                            // This will ensure that after the form was succesfully submitted the form is both
                            // - Scrolled to the top again
                            // - Reset to its initial state
                            event.target.closest('main').scrollTop = 0;
                            event.target.reset();
                        }, 300); // Same timeout as is used for pushbar animation
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
                event.target.removeEventListener('submit', handleActualSubmit);
            });
        document.querySelector('.js-edit-class-drawer .js-edit-class-form button').click();
    }

    editRecurringClass() {
        const that = this;
        document.querySelector('.js-edit-class-drawer .js-edit-class-form').action = route('edit_class_in_schedule', {
            scheduleId: this.props.event.extendedProps.eventId
        });
        document
            .querySelector('.js-edit-class-drawer .js-edit-class-form')
            .addEventListener('submit', function handleActualSubmit(event) {
                event.preventDefault();

                const loader = event.target.closest('aside').getElementsByClassName('js-loader')[0];
                if (loader) {
                    loader.style.display = 'block';
                }

                const formData = new FormData(event.target);

                const dataToSend = {};

                for (let data of formData) {
                    dataToSend[data[0]] = data[1];
                }

                axios
                    .post(event.target.action, dataToSend)
                    .then(function (result) {
                        if (loader) {
                            loader.style.display = 'none';
                        }
                        event.target.closest('.pushbar').Pushbar.closeAll();
                        that.props.refresh();

                        setTimeout(function () {
                            // This will ensure that after the form was succesfully submitted the form is both
                            // - Scrolled to the top again
                            // - Reset to its initial state
                            event.target.closest('main').scrollTop = 0;
                            event.target.reset();
                        }, 300); // Same timeout as is used for pushbar animation
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
                event.target.removeEventListener('submit', handleActualSubmit);
            });
        document.querySelector('.js-edit-class-drawer .js-edit-class-form button').click();
    }

    editAllClass() {
        const that = this;
        document.querySelector('.js-edit-class-drawer .js-edit-class-form').action = route(
            'edit_class_in_schedule_all',
            {
                scheduleId: this.props.event.extendedProps.eventId
            }
        );
        document
            .querySelector('.js-edit-class-drawer .js-edit-class-form')
            .addEventListener('submit', function handleActualSubmit(event) {
                event.preventDefault();

                const loader = event.target.closest('aside').getElementsByClassName('js-loader')[0];
                if (loader) {
                    loader.style.display = 'block';
                }

                const formData = new FormData(event.target);

                const dataToSend = {};

                for (let data of formData) {
                    dataToSend[data[0]] = data[1];
                }

                axios
                    .post(event.target.action, dataToSend)
                    .then(function (result) {
                        if (loader) {
                            loader.style.display = 'none';
                        }
                        event.target.closest('.pushbar').Pushbar.closeAll();
                        that.props.refresh();

                        setTimeout(function () {
                            // This will ensure that after the form was succesfully submitted the form is both
                            // - Scrolled to the top again
                            // - Reset to its initial state
                            event.target.closest('main').scrollTop = 0;
                            event.target.reset();
                        }, 300); // Same timeout as is used for pushbar animation
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
                event.target.removeEventListener('submit', handleActualSubmit);
            });
        document.querySelector('.js-edit-class-drawer .js-edit-class-form button').click();
    }

    deleteClass() {
        this.setState({
            showLoader: true
        });
        axios
            .get(
                route('schedule_delete_one', {
                    box: this.props.event.extendedProps.boxSlug,
                    scheduleId: this.props.event.extendedProps.eventId,
                    scheduleDate: moment(this.props.event.start).format('YYYY-MM-DD HH:mm:ss')
                })
            )
            .then(() => {
                document.querySelector('.js-detail-drawer-react').Pushbar.closeAll();
                this.props.refresh();
            })
            .catch(error => {
                Bugsnag.notify(error);
            })
            .then(() => {
                this.setState({ showLoader: false });
            });
    }

    deleteRecurringClass() {
        this.setState({
            showLoader: true
        });
        axios
            .get(
                route('schedule_delete_recurring', {
                    box: this.props.event.extendedProps.boxSlug,
                    scheduleId: this.props.event.extendedProps.eventId,
                    scheduleDate: moment(this.props.event.start).format('YYYY-MM-DD HH:mm:ss')
                })
            )
            .then(() => {
                document.querySelector('.js-detail-drawer-react').Pushbar.closeAll();
                this.props.refresh();
            })
            .catch(error => {
                Bugsnag.notify(error);
            })
            .then(() => {
                this.setState({ showLoader: false });
            });
    }

    deleteAllClass() {
        this.setState({
            showLoader: true
        });
        axios
            .get(
                route('schedule_delete_all', {
                    box: this.props.event.extendedProps.boxSlug,
                    scheduleId: this.props.event.extendedProps.eventId,
                    scheduleDate: moment(this.props.event.start).format('YYYY-MM-DD HH:mm:ss')
                })
            )
            .then(() => {
                document.querySelector('.js-detail-drawer-react').Pushbar.closeAll();
                this.props.refresh();
            })
            .catch(error => {
                Bugsnag.notify(error);
            })
            .then(() => {
                this.setState({ showLoader: false });
            });
    }

    editWorkout() {
        document.querySelector(
            '.js-edit-workout-in-schedule-drawer input[name="workout_id"]'
        ).value = this.props.event.extendedProps.workoutId;
        document.querySelector(
            '.js-edit-workout-in-schedule-drawer input[name="title"]'
        ).parentNode.MDCTextField.value = this.state.classTypeDetails.title;
        document.querySelector(
            '.js-edit-workout-in-schedule-drawer select[name="category_id"]'
        ).parentNode.MDCSelect.value = this.props.event.extendedProps.categoryId;
        document.querySelector(
            '.js-edit-workout-in-schedule-drawer textarea[name="workout_details"]'
        ).parentNode.MDCTextField.value = this.state.classTypeDetails.description;
        document.querySelector(
            '.js-edit-workout-in-schedule-drawer textarea[name="extra_information"]'
        ).parentNode.MDCTextField.value = this.state.classTypeDetails.extra_information || '';
        document.querySelector('.js-edit-workout-in-schedule-drawer').Pushbar.open();
    }

    deleteWorkout() {
        axios
            .get(
                route('schedule_delete_workout', {
                    box: this.props.event.extendedProps.boxSlug,
                    scheduleId: this.props.event.extendedProps.eventId,
                    scheduleDate: moment(this.props.event.start).format('YYYY-MM-DD'),
                    workoutId: this.props.event.extendedProps.workoutId
                })
            )
            .then(() => {
                document.querySelector('.js-detail-drawer-react').Pushbar.closeAll();
                this.props.refresh();
            })
            .catch(error => {
                Bugsnag.notify(error);
            });
    }

    subscribeToEvent() {
        if (this.state.isSubscribing) {
            return;
        }

        this.setState({
            isSubscribing: true,
            showLoader: true
        });

        const startDate = moment(this.props.event.start).format('YYYY-MM-DDTHH:mm:ss');
        const endDate = moment(this.props.event.end).format('YYYY-MM-DDTHH:mm:ss');
        const classTypeId = this.props.event.extendedProps.classTypeId;
        const event = this.props.el;

        axios
            .post(route('subscribe_to_schedule_item'), {
                startDate,
                endDate,
                classTypeId
            })
            .then(response => {
                event.style.backgroundColor = 'rgb(74, 139, 254)';
                event.classList.add('signed');
                event
                    .querySelector('.fc-content')
                    .insertBefore(
                        createElementFromHTML(
                            '<div class="text-center event_status">\n' +
                                '            <i class="material-icons text-white workout_check">check</i>\n' +
                                '            </div>'
                        ),
                        event.querySelector('.fc-content').querySelector('.fc-title')
                    );
                document.querySelector('.js-detail-drawer-react').Pushbar.close();
                if (response.status === 201) {
                    document.querySelector('.js-subscribed-success-snackbar').MDCSnackbar.open();
                } else {
                    document.querySelector('.js-subscribed-failure-event-full-snackbar').MDCSnackbar.open();
                }
                this.setState({
                    isSubscribing: false,
                    showLoader_image: false
                });

                this.props.event.setProp('backgroundColor', 'rgb(74, 139, 254)');
                this.props.event.setExtendedProp('subscribed', true);
                this.props.refresh();
            })
            .catch(error => {
                Bugsnag.notify(error);
            });
    }



    subscribeToEventByCoach(userId) {
        this.setState({
            showLoader: true
        });

        const startDate = moment(this.props.event.start).format('YYYY-MM-DDTHH:mm:ss');
        const endDate = moment(this.props.event.end).format('YYYY-MM-DDTHH:mm:ss');
        const classTypeId = this.props.event.extendedProps.classTypeId;

        axios
            .post(route('subscribe_to_schedule_item_by_coach'), {
                startDate,
                endDate,
                classTypeId,
                userId
            })
            .then(response => {
                this.fetchClassTypeDetails();
            })
            .catch(error => {
                Bugsnag.notify(error);
            });
    }

    addToWaitingList() {
        const startDate = moment(this.props.event.start).format('YYYY-MM-DDTHH:mm:ss');
        const endDate = moment(this.props.event.end).format('YYYY-MM-DDTHH:mm:ss');
        const classTypeId = this.props.event.extendedProps.classTypeId;
        const event = this.props.el;
        const shouldAddOnWaitingList = true;

        axios
            .post(route('subscribe_to_schedule_item'), {
                startDate,
                endDate,
                classTypeId,
                shouldAddOnWaitingList
            })
            .then(() => {
                event.style.backgroundColor = 'rgba(74,139,254,0.5)';
                event.classList.add('waiting-list');
                event
                    .querySelector('.fc-content')
                    .insertBefore(
                        createElementFromHTML(
                            '<div class="text-center event_status">\n' +
                                '            <i class="material-icons workout_check">alarm</i>\n' +
                                '            </div>'
                        ),
                        event.querySelector('.fc-content').querySelector('.fc-title')
                    );
                document.querySelector('.js-detail-drawer-react').Pushbar.close();
                document.querySelector('.js-added-to-waiting-list-success-snackbar').MDCSnackbar.open();
                this.props.refresh();
            })
            .catch(error => {
                Bugsnag.notify(error);
            });
    }

    removeFromWaitingList() {
        const scheduleRegistrationId = this.state.classTypeDetails.scheduleRegistrationId;
        const event = this.props.el;
        const classTypeId = this.props.event.extendedProps.classTypeId;
        const shouldRemoveFromWaitingList = true;

        axios
            .post(route('unsubscribe_from_schedule_item'), {
                scheduleRegistrationId,
                classTypeId,
                shouldRemoveFromWaitingList
            })
            .then(() => {
                event.style.backgroundColor = 'rgb(255, 255, 255)';
                event.classList.remove('waiting-list');
                const toRemove = event.querySelector('.fc-content').querySelector('.event_status');
                event.querySelector('.fc-content').removeChild(toRemove);
                document.querySelector('.js-detail-drawer-react').Pushbar.close();
                document.querySelector('.js-removed-to-waiting-list-success-snackbar').MDCSnackbar.open();
                this.props.refresh();
            })
            .catch(error => {
                Bugsnag.notify(error);
            });
    }

    unsubscribeFromEvent() {
        if (this.state.isUnsubscribing) {
            return;
        }

        this.setState({
            isUnsubscribing: true,
            showLoader: true
        });

        const scheduleRegistrationId = this.state.classTypeDetails.scheduleRegistrationId;
        const classTypeId = this.props.event.extendedProps.classTypeId;
        const event = this.props.el;

        axios
            .post(route('unsubscribe_from_schedule_item'), {
                scheduleRegistrationId,
                classTypeId
            })
            .then(() => {
                event.style.backgroundColor = 'rgb(255, 255, 255)';
                event.classList.remove('signed');
                const toRemove = event.querySelector('.fc-content').querySelector('.event_status');
                event.querySelector('.fc-content').removeChild(toRemove);
                document.querySelector('.js-detail-drawer-react').Pushbar.close();
                document.querySelector('.js-unsubscribed-success-snackbar').MDCSnackbar.open();
                this.setState({
                    isUnsubscribing: false,
                    showLoader: false
                });
                this.props.event.setProp('backgroundColor', 'white');
                this.props.event.setExtendedProp('subscribed', false);
                this.props.refresh();

            })
            .catch(error => {
                Bugsnag.notify(error);
            });
    }


    unsubscribeFromEventByCoach(scheduleRegistrationId, userId) {
        this.setState({
            showLoader: true
        });
        axios
            .post(route('unsubscribe_from_schedule_item_by_coach'), {
                scheduleRegistrationId,
                userId
            })
            .then(() => {
                this.fetchClassTypeDetails();
            })
            .catch(error => {
                Bugsnag.notify(error);
            });
    }

    modifyNoShow(scheduleRegistrationId, isNoShow) {
        this.setState({
            showLoader: true
        });
        axios
            .post(route('modify_no_show'), {
                scheduleRegistrationId,
                isNoShow
            })
            .then(() => {
                this.fetchClassTypeDetails();
            })
            .catch(error => {
                Bugsnag.notify(error);
            });
    }

    componentDidMount() {
        this.setState({
            showLoader: true
        });
        this.fetchClassTypeDetails();

        // Access the logo image URL from the global variable
        if (window.boxLogoImage) {
          this.setState({
            logoImage: window.boxLogoImage, // Set the logoImage state
          });
        }

    }

    fetchClassTypeDetails() {
        axios
            .get(
                route('class_type_details', {
                    classTypeId: this.props.event.extendedProps.classTypeId,
                    eventId: this.props.event.extendedProps.eventId,
                    eventDate: moment(this.props.event.start).format('YYYY-MM-DDTHH:mm:ss'),
                    eventEndDate: moment(this.props.event.end).format('YYYY-MM-DDTHH:mm:ss')
                })
            )
            .then(response => {
                const membersToAdd = response.data.athletes.filter(
                    user => !response.data.signedUpUsers.map(user => user.id).includes(user.id)
                );
                let addMemberSelectValue = {};
                if (membersToAdd.length > 0) {
                    const firstMember = membersToAdd[0];
                    addMemberSelectValue = {
                        label: firstMember.first_name + ' ' + firstMember.surname,
                        value: firstMember.id
                    };
                }
                this.setState({
                    classTypeDetails: response.data,
                    addMemberSelectValue: addMemberSelectValue,
                    addMemberSelectInputValue: addMemberSelectValue.label,
                    showLoader: false
                });
            })
            .catch(error => {
                Bugsnag.notify(error);
            });
    }


    render() {

        const { imageSrc } = this.state; // Get image source from state

        return (
            <div>
                <button
                    data-pushbar-close
                    type="button"
                    className="close push_right"
                    data-dismiss="modal"
                    aria-label="Close"
                    onClick={() => document.querySelector('.js-detail-drawer-react').Pushbar.close()}
                >
                    <span aria-hidden="true">&times;</span>
                </button>
                <div className="header-visual">
                    <img src="/images/wod.png" />
                </div>
                <div className="container p-0" style={{ position: 'relative' }}>
                    {this.state.showLoader && (
                        <div
                            role="progressbar"
                            className="mdc-linear-progress mdc-linear-progress--indeterminate js-loader"
                            style={{
                                position: 'absolute',
                                zIndex: 100,
                                left: 0,
                                top: 0
                            }}
                        >
                            <div className="mdc-linear-progress__buffering-dots"></div>
                            <div className="mdc-linear-progress__buffer"></div>
                            <div className="mdc-linear-progress__bar mdc-linear-progress__primary-bar">
                                <span className="mdc-linear-progress__bar-inner"></span>
                            </div>
                            <div className="mdc-linear-progress__bar mdc-linear-progress__secondary-bar">
                                <span className="mdc-linear-progress__bar-inner"></span>
                            </div>
                        </div>
                    )}

                    <div className="d-flex align-items-center pt-3 pb-3 pl-4 pr-4 border border-bottom">
                        <h2 className="js-detail-title" data-cy="detail-title">
                            {this.props.event.title}
                        </h2>
                    </div>
                    <div className="border-bottom position-relative pr-4 pl-4">
                        <div className="modal-content-block">
                            {this.props.event.extendedProps.isAdmin && (
                                <SimpleMenu
                                    style={{
                                        position: 'absolute',
                                        top: 0,
                                        right: 0,
                                        left: 'initial'
                                    }}
                                    handle={
                                        <button className="ml-auto mdl-list__item-secondary-action  mdl-button--raised  mdl-button mdl-js-button mdl-button--icon no-shadow">
                                            <i className="material-icons">edit</i>
                                        </button>
                                    }
                                >
                                    <h6 className="dropdown-header">Class</h6>
                                    <MenuItem
                                        onClick={() => {
                                            if (this.props.event.extendedProps.isRecurring) {
                                                this.openEditRecurringForm();
                                            } else {
                                                this.editOneTimeClass();
                                            }
                                        }}
                                    >
                                        Edit
                                    </MenuItem>
                                    <MenuItem
                                        onClick={() => {
                                            if (this.props.event.extendedProps.isRecurring) {
                                                this.setState({ deleteRecurringOpen: true });
                                            } else {
                                                this.deleteClass();
                                            }
                                        }}
                                    >
                                        Delete
                                    </MenuItem>
                                </SimpleMenu>
                            )}
                            <i className="material-icons">access_time</i>
                            <div className="d-flex">
                                <div>
                                    <h3 className="modal-title-content js-detail-date">
                                        {moment(this.props.event.start).format('dddd D MMMM')}
                                    </h3>
                                    <p className="js-detail-time m-0">
                                        {moment(this.props.event.start).format('HH:mm') +
                                            ' - ' +
                                            moment(this.props.event.end).format('HH:mm')}
                                    </p>
                                </div>

                                {!this.props.event.extendedProps.isAdmin &&(
                                    <div className="ml-auto">
                                        <SimpleMenu handle={<button className="mdl-button--raised mdl-button mdl-js-button mdl-button--icon no-shadow">
                                            <i className="material-icons material-symbols-outlined">calendar_add_on</i>
                                        </button>}>
                                            <h6 className="dropdown-header">Add to calendar</h6>
                                            <MenuItem onClick={() => this.handleCalendarOptionClick('icalendar')}>iCalendar</MenuItem>
                                            <MenuItem onClick={() => this.handleCalendarOptionClick('google')}>Google Calendar</MenuItem>
                                            <MenuItem onClick={() => this.handleCalendarOptionClick('outlook')}>Outlook</MenuItem>
                                        </SimpleMenu>
                                    </div>
                                )}

                            </div>

                            {this.state.classTypeDetails &&
                                !this.state.classTypeDetails.isAdmin &&
                                !this.state.classTypeDetails.subscribed &&
                                this.state.classTypeDetails.canSubscribe && (
                                    <div className="js-subscribe-to-event-container">
                                        <p className="m-0 mt-2 text-secondary">
                                            You have{' '}
                                            <span className="text-primary">
                                                <strong className="js-credits-remaining">
                                                    {this.state.classTypeDetails.creditsRemaining}
                                                </strong>
                                            </span>
                                            &nbsp;
                                            {this.state.classTypeDetails.creditsRemaining === 1
                                                ? 'credit'
                                                : 'credits'}{' '}
                                            left
                                            {this.state.classTypeDetails.hasSubscriptionBasedMembership
                                                ? ' this week'
                                                : ''}
                                            .
                                        </p>
                                        <button
                                            className="mdc-button mdc-button--raised mt-3"
                                            disabled={this.state.isSubscribing}
                                            onClick={() => this.subscribeToEvent()}
                                            data-mdc-auto-init="MDCRipple"
                                        >
                                            <span className="mdc-button__label">Sign in</span>
                                        </button>
                                    </div>
                                )}
                            {this.state.classTypeDetails &&
                                !this.state.classTypeDetails.isAdmin &&
                                this.state.classTypeDetails.canAddToWaitingList && (
                                    <div>
                                        <div className="alert alert-light alert-small mt-3 mb-0 p-2" role="alert">
                                            This event is fully packed! But you can add yourself on the waiting list.
                                        </div>
                                        <button
                                            onClick={() => this.addToWaitingList()}
                                            className="mdc-button mdc-button--raised mt-3"
                                            data-mdc-auto-init="MDCRipple"
                                        >
                                            <span className="mdc-button__label">Add to waiting list</span>
                                        </button>
                                    </div>
                                )}
                            {this.state.classTypeDetails &&
                                !this.state.classTypeDetails.isAdmin &&
                                this.state.classTypeDetails.canRemoveFromWaitingList && (
                                    <button
                                        onClick={() => this.removeFromWaitingList()}
                                        className="mdc-button mt-3"
                                        data-mdc-auto-init="MDCRipple"
                                    >
                                        <span className="mdc-button__label">Remove from waiting list</span>
                                    </button>
                                )}
                            {this.state.classTypeDetails &&
                                !this.state.classTypeDetails.isAdmin &&
                                this.state.classTypeDetails.subscribed &&
                                this.state.classTypeDetails.canUnsubscribe && (
                                    <div className="js-unsubscribe-from-event-container">
                                        <p className="m-0 mt-2 text-secondary">
                                            You have{' '}
                                            <span className="text-primary">
                                                <strong className="js-credits-remaining">
                                                    {this.state.classTypeDetails.creditsRemaining}
                                                </strong>
                                            </span>
                                            &nbsp;
                                            {this.state.classTypeDetails.creditsRemaining === 1
                                                ? 'credit'
                                                : 'credits'}{' '}
                                            left
                                            {this.state.classTypeDetails.hasSubscriptionBasedMembership
                                                ? ' this week'
                                                : ''}
                                            .
                                        </p>
                                        <button
                                            className="mdc-button mdc-button--raised mt-3"
                                            disabled={this.state.isUnsubscribing}
                                            onClick={() => this.unsubscribeFromEvent()}
                                            data-mdc-auto-init="MDCRipple"
                                        >
                                            <span className="mdc-button__label">Sign out</span>
                                        </button>
                                    </div>
                                )}
                        </div>
                    </div>
                    {this.state.classTypeDetails && (
                        <div>
                            {(this.state.classTypeDetails.has_workout ||
                                this.state.classTypeDetails.description ||
                                this.props.event.extendedProps.isAdmin) && (
                                <div className="border-bottom position-relative pr-4 pl-4 js-all-event-info">
                                    <div className="modal-content-block js-content-workout">
                                        {this.props.event.extendedProps.isAdmin &&
                                            this.state.classTypeDetails.has_workout && (
                                                <SimpleMenu
                                                    style={{
                                                        position: 'absolute',
                                                        top: 0,
                                                        right: 0,
                                                        left: 'initial'
                                                    }}
                                                    handle={
                                                        <button className="ml-auto mdl-list__item-secondary-action  mdl-button--raised  mdl-button mdl-js-button mdl-button--icon no-shadow">
                                                            <i className="material-icons">edit</i>
                                                        </button>
                                                    }
                                                >
                                                    <h6 className="dropdown-header">Workout</h6>
                                                    <MenuItem onClick={() => this.openAddWorkoutDrawer()}>
                                                        Add new workout
                                                    </MenuItem>
                                                    <MenuItem onClick={() => this.editWorkout()}>Edit workout</MenuItem>
                                                    <MenuItem onClick={() => this.deleteWorkout()}>
                                                        Delete workout
                                                    </MenuItem>
                                                </SimpleMenu>
                                            )}
                                        {this.state.classTypeDetails.has_workout && (
                                            <div>
                                                <i className="material-icons">assignment</i>
                                                <h3
                                                    className="modal-title-content js-workout-title"
                                                    data-cy="workout-title"
                                                >
                                                    {this.state.classTypeDetails.title}
                                                </h3>
                                                <div>
                                                <p
                                                    className="workout-description js-workout-description"
                                                    style={{
                                                        whiteSpace: 'pre-line'
                                                    }}
                                                    dangerouslySetInnerHTML={linkify(
                                                        this.state.classTypeDetails.description
                                                    )}
                                                ></p>
                                                </div>
                                                <div>
                                                    <button className="mdc-button mdc-ripple-upgraded mt-2" data-mdc-auto-init="MDCRipple" onClick={this.handleOpenDialog}>
                                                      <span className="mdc-button__label">Share this workout</span>
                                                    </button>
                                                </div>

                                                </div>

                                        )}
                                    </div>



                                    {!this.state.classTypeDetails.has_workout &&
                                        this.state.classTypeDetails.description && (
                                            <div className="modal-content-block js-content-no-workout">
                                                <i className="material-icons">assignment</i>
                                                <p
                                                    className="js-no-workout-description"
                                                    dangerouslySetInnerHTML={linkify(
                                                        this.state.classTypeDetails.description
                                                    )}
                                                ></p>

                                                <p>
                                                </p>
                                            </div>
                                        )}

                                    {this.state.classTypeDetails.extra_information && (
                                        <div className="modal-content-block js-content-workout js-workout-extra-info-container">
                                            <i className="material-icons">information</i>
                                            <h3 className="modal-title-content">Extra information</h3>
                                            <p
                                                className="js-workout-extra-info"
                                                dangerouslySetInnerHTML={linkify(
                                                    this.state.classTypeDetails.extra_information
                                                )}
                                            ></p>
                                        </div>
                                    )}
                                    {this.props.event.extendedProps.isAdmin && (
                                        <div className="modal-content-block">
                                            <button
                                                className="mdc-button mdc-button--raised js-add-workout-button"
                                                onClick={() => this.openAddWorkoutDrawer()}
                                                data-mdc-auto-init="MDCRipple"
                                                dusk="add-workout-to-event"
                                                data-cy="add-workout-to-event"
                                            >
                                                <span className="mdc-button__label">Add workout</span>
                                            </button>
                                        </div>
                                    )}



                                </div>
                            )}

                            <div className="border-bottom position-relative pr-4 pl-4 js-athletes-info">
                                <div className="modal-content-block d-flex align-items-center">
                                    <i className="material-icons">person</i>
                                    <div className="d-flex align-items-center w-100">
                                        <p className="m-0">
                                            <span className="js-event-registration-info">
                                                {this.state.classTypeDetails.totalRegistrations}/
                                                {this.state.classTypeDetails.totalPossibleRegistrations}
                                            </span>{' '}
                                            Members signed
                                        </p>
                                        {this.props.event.extendedProps.isAdmin &&
                                            this.state.classTypeDetails.athletes.filter(
                                                user =>
                                                    !this.state.classTypeDetails.signedUpUsers
                                                        .map(user => user.id)
                                                        .includes(user.id)
                                            ).length > 0 && (
                                                <button
                                                    onClick={() =>
                                                        this.setState({
                                                            addMemberOpen: true
                                                        })
                                                    }
                                                    className="mdc-button js-add-member-button ml-auto"
                                                    data-mdc-auto-init="MDCRipple"
                                                >
                                                    <span className="mdc-button__label">Add member</span>
                                                </button>
                                            )}
                                    </div>
                                </div>
                                {this.state.classTypeDetails.signedUpUsers.length > 0 && (
                                <div className="modal-content-block">
                                    <ul className="usp-list participant_list js-participant-list mb-0">
                                        {this.state.classTypeDetails.signedUpUsers.map((user, i) => (
                                            <li
                                                className={
                                                    'pl-0 d-flex align-items-center ' +
                                                    (user.is_no_show ? 'no_show' : '')
                                                }
                                                key={i}
                                            >
                                                <span className="avatar mobile">
                                                    {user.first_name[0]}
                                                    {user.surname[0]}
                                                </span>
                                                <span className="list_name">
                                                    {user.first_name} {user.surname}
                                                </span>
                                                {this.props.event.extendedProps.isAdmin && (
                                                    <div
                                                        style={{
                                                            marginLeft: 'auto'
                                                        }}
                                                    >
                                                        <SimpleMenu
                                                            hoistToBody={true}
                                                            handle={
                                                                <button className="mdl-button--raised  mdl-button mdl-js-button mdl-button--icon no-shadow">
                                                                    <i className="material-icons">more_vert</i>
                                                                </button>
                                                            }
                                                        >
                                                            <MenuItem
                                                                onClick={() =>
                                                                    this.modifyNoShow(
                                                                        user.schedule_registration_id,
                                                                        !user.is_no_show
                                                                    )
                                                                }
                                                            >
                                                                {user.is_no_show && (
                                                                    <i
                                                                        className="material-icons"
                                                                        style={{
                                                                            position: 'initial',
                                                                            top: 'inherit',
                                                                            left: 'inherit',
                                                                            marginRight: '4px'
                                                                        }}
                                                                    >
                                                                        check
                                                                    </i>
                                                                )}
                                                                No show
                                                            </MenuItem>
                                                            <MenuItem
                                                                onClick={() =>
                                                                    this.unsubscribeFromEventByCoach(
                                                                        user.schedule_registration_id,
                                                                        user.id
                                                                    )
                                                                }
                                                            >
                                                                Remove
                                                            </MenuItem>
                                                        </SimpleMenu>
                                                    </div>
                                                )}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                                )}
                            </div>


                            {this.state.classTypeDetails.waitingListUsers.length > 0 && (
                                <div className="border-bottom position-relative pr-4 pl-4 js-athletes-info-waiting-list">
                                    <div className="modal-content-block">
                                        <i className="material-icons">person_outline</i>
                                        <p className="m-0">
                                            <span className="js-event-registration-info-waiting-list">
                                                {this.state.classTypeDetails.totalUsersOnWaitingList}
                                            </span>{' '}
                                            Members on waiting list
                                        </p>
                                        <ul className="usp-list participant_list js-waiting-list mb-0">
                                            {this.state.classTypeDetails.waitingListUsers.map((user, i) => (
                                                <li className="pl-0" key={i}>
                                                    <span className="avatar mobile">
                                                        {user.first_name[0]}
                                                        {user.surname[0]}
                                                    </span>{' '}
                                                    {user.first_name} {user.surname}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            )}

                            <Dialog
                                open={this.state.addMemberOpen}
                                onClose={evt => {
                                    if (evt.detail.action === 'add_member') {
                                        this.subscribeToEventByCoach(this.state.addMemberSelectValue.value);
                                    }
                                    this.setState({
                                        addMemberOpen: false
                                    });
                                }}
                            >
                                <DialogTitle>Add member</DialogTitle>
                                <DialogContent>
                                    Select and add a member to this event.
                                    <br />
                                    <br />
                                    <Autocomplete
                                        openOnFocus
                                        onKeyDown={event => {
                                            if (event.key === 'Enter') {
                                                // Prevent dialog from closing when pressing Enter
                                                event.stopPropagation();
                                            }
                                        }}
                                        isOptionEqualToValue={(option, value) => option.value === value.value}
                                        getOptionLabel={option => {
                                            if (Object.keys(option).length === 0) {
                                                return '';
                                            }
                                            return option.label;
                                        }}
                                        options={this.state.classTypeDetails.athletes
                                            .filter(
                                                user =>
                                                    !this.state.classTypeDetails.signedUpUsers
                                                        .map(user => user.id)
                                                        .includes(user.id)
                                            )
                                            .map(user => {
                                                return {
                                                    label: user.first_name + ' ' + user.surname,
                                                    value: user.id
                                                };
                                            })}
                                        value={this.state.addMemberSelectValue}
                                        onChange={(event, newValue) => {
                                            this.setState({
                                                addMemberSelectValue: newValue
                                            });
                                        }}
                                        inputValue={this.state.addMemberSelectInputValue}
                                        onInputChange={(event, newValue) => {
                                            this.setState({
                                                addMemberSelectInputValue: newValue
                                            });
                                        }}
                                        renderInput={params => {
                                            params.InputProps.sx = { fontSize: '16px' };
                                            return <TextField {...params} label="Select member to add" />;
                                        }}
                                    />
                                </DialogContent>
                                <DialogActions>
                                    <DialogButton action="close">Cancel</DialogButton>
                                    <DialogButton action="add_member" isDefaultAction>
                                        Add member
                                    </DialogButton>
                                </DialogActions>
                            </Dialog>
                            <Dialog
                                open={this.state.deleteRecurringOpen}
                                onClose={evt => {
                                    if (evt.detail.action === 'ok') {
                                        if (this.state.deleteRecurringValue === 'this-event') {
                                            this.deleteClass();
                                        } else if (this.state.deleteRecurringValue === 'this-and-following-events') {
                                            this.deleteRecurringClass();
                                        } else if (this.state.deleteRecurringValue === 'all-events') {
                                            this.deleteAllClass();
                                        }
                                    }
                                    this.setState({
                                        deleteRecurringOpen: false
                                    });
                                }}
                            >
                                <DialogTitle>Delete recurring event</DialogTitle>
                                <DialogContent>
                                    <div>
                                        <Radio
                                            value="this-event"
                                            checked={this.state.deleteRecurringValue === 'this-event'}
                                            onChange={evt =>
                                                this.setState({
                                                    deleteRecurringValue: String(evt.currentTarget.value)
                                                })
                                            }
                                        >
                                            This event
                                        </Radio>
                                    </div>
                                    <div>
                                        <Radio
                                            value="this-and-following-events"
                                            checked={this.state.deleteRecurringValue === 'this-and-following-events'}
                                            onChange={evt =>
                                                this.setState({
                                                    deleteRecurringValue: String(evt.currentTarget.value)
                                                })
                                            }
                                        >
                                            This and following events
                                        </Radio>
                                    </div>
                                    <div>
                                        <Radio
                                            value="all-events"
                                            checked={this.state.deleteRecurringValue === 'all-events'}
                                            onChange={evt =>
                                                this.setState({
                                                    deleteRecurringValue: String(evt.currentTarget.value)
                                                })
                                            }
                                        >
                                            All events
                                        </Radio>
                                    </div>
                                </DialogContent>
                                <DialogActions>
                                    <DialogButton action="close">Cancel</DialogButton>
                                    <DialogButton action="ok" isDefaultAction>
                                        Ok
                                    </DialogButton>
                                </DialogActions>
                            </Dialog>

                            <Dialog open={this.state.isDialogOpen} onClose={this.handleCloseDialog}>
                                <DialogTitle>Share your workout</DialogTitle>
                                <DialogContent>
                                    {/* Conditionally render the image if imageSrc exists */}
                                    {this.state.imageSrc && (
                                        <img src={this.state.imageSrc} alt="Generated Image" className="generatedimage" onClick={() => this.handleDownloadImage(this.state.imageSrc, `workout_${this.state.classTypeDetails.title}.png`)}/>
                                    )}

                                    {/* Conditionally render workout-imageblock based on imageSrc */}
                                    {!this.state.imageSrc && (
                                        <div className="workout-imageblock position-relative">
                                            {this.state.showLoader_image && (
                                                <div className="loader-block d-flex align-items-center justify-content-center position-absolute w-100 h-100">
                                                    <div className="loader"></div>
                                                </div>
                                            )}

                                            <div id="capture-content" ref={this.captureContentRef}>
                                                <div className="imageshareblock">
                                                    <img src={this.state.logoImage} className="logo__bussiness" alt="Logo" />
                                                    <img src="/images/workoutoftheday.png" className="header_image_wod" alt="Logo" />
                                                    <div className="background">
                                                        <div className="workout-shareblock">
                                                            <span className="workout-title" data-cy="workout-title">
                                                                {this.state.classTypeDetails.title}
                                                            </span>
                                                            <p
                                                                className="workout-description js-workout-description"
                                                                style={{
                                                                    whiteSpace: 'pre-line',
                                                                }}
                                                                dangerouslySetInnerHTML={
                                                                    this.state.classTypeDetails.description
                                                                        ? linkify(this.state.classTypeDetails.description)
                                                                        : { __html: '' } // Set an empty value if description is null
                                                                }
                                                            ></p>
                                                        </div>
                                                    </div>
                                                    <img src="/images/logo_color.svg" className="logo_fitblocks" alt="Logo" />
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </DialogContent>
                                <DialogActions>
                                    <DialogButton action="download" onClick={() => this.handleDownloadImage(this.state.imageSrc, `workout_${this.state.classTypeDetails.title}.png`)}>
                                        Download
                                    </DialogButton>
                                    <DialogButton action="close" onClick={this.handleCloseDialog}>Cancel</DialogButton>
                                </DialogActions>
                            </Dialog>




                        </div>
                    )}
                </div>

            </div>
        );
    }
}
